import loginFormValidator, { LoginFormValidator } from './loginFormValidator';

export interface RegistrationFormValidator extends LoginFormValidator {
    isTermsAccepted?: boolean;
    isClubNewsletterSubscribed?: boolean;
}

export default (formValues: RegistrationFormValidator, isShopToClubRegistration: boolean = false) => {
    let errors: RegistrationFormValidator = {};

    const loginFormErrors = loginFormValidator(formValues);
    errors = { ...loginFormErrors };

    if (isShopToClubRegistration) {
        if (!formValues.isClubNewsletterSubscribed) {
            errors.isClubNewsletterSubscribed = true;
        }
    } else if (!formValues.isTermsAccepted) {
        errors.isTermsAccepted = true;
    }
    return errors;
};
